import { authGuard } from '@auth0/auth0-vue';
import { setupChunkErrorReload } from '@marketspark/ui/utils/chunkErrorReload';
import { createRouter, createWebHistory } from 'vue-router';

import { APP_URLS, BASIFY } from '@/constants';
import { ROUTE_NAMES } from '@/router/routes.constants';

import AuthRoutes from './AuthRoutes';
import DashboardRoutes from './DashboardRoutes';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: ROUTE_NAMES.NOT_FOUND,
      path: '/:pathmatch(.*)*',
      component: () => import('../views/404Page.vue'),
    },
    {
      name: ROUTE_NAMES.ERROR,
      path: '/error',
      component: () => import('../layouts/EmptyLayout.vue'),
      children: [
        {
          name: ROUTE_NAMES.ERROR_PAGE,
          path: '',
          component: () => import('../views/ErrorPage.vue'),
        },
      ],
    },
    DashboardRoutes,
    AuthRoutes,
    // Ideally this doesn't live in this UI long
    {
      name: ROUTE_NAMES.DOCS,
      path: BASIFY(APP_URLS.docs),
      meta: {
        requiresAuth: true,
      },
      beforeEnter: authGuard,
      component: () => import('@/views/DocsPage.vue'),
    },
  ],
});

setupChunkErrorReload();

export default router;
